import { useGetClientByIdQuery, useUpdateClientMutation } from '@entities/clients/rtk-query.ts';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClientAboutEditPageRedirect } from '@pages/clients/client-about-page/edit-page/helpers.ts';
import descriptionEditorStyles from '@pages/common/descriptionEditorPage/styles.module.scss';
import { DescriptionEditor } from '@widgets/shared/descriptionEditor/index.tsx';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { ListBody, PageHead, PageTitle, TextButton } from '@shared/ui/index.ts';
import { Loader } from '@src/library/components/common/index.ts';

type PT = {};

export const ClientAboutEditPage = ({}: PT) => {
  const { clientId } = useParams();

  const [description, setDescription] = useState('');

  const {
    data: client,
    isLoading: isGetClientLoading,
    isFetching: isGetClientFetching,
  } = useGetClientByIdQuery(Number(clientId), { skip: !clientId });

  const [updateClientMutation, { isLoading: isUpdateClientLoading }] = useUpdateClientMutation();

  const { doRedirectOnPrevPage } = useClientAboutEditPageRedirect();

  const closePage = () => doRedirectOnPrevPage('/clients/clients');

  const handleClickSubmit = async () => {
    const formData = new FormData();
    formData.append('description', description);
    if (client) {
      await updateClientMutation({ id: client.id, body: formData });
    }
    closePage();
  };

  const bodyJSX = useMemo(() => {
    if (isGetClientLoading || isGetClientFetching) {
      return <Loader />;
    }
    if (client) {
      return <DescriptionEditor value={description} onChange={setDescription} />;
    } else {
      return 'Не найден клиент';
    }
  }, [isGetClientLoading, isGetClientFetching, client, description, setDescription]);

  useEffect(() => {
    if (clientId && client && client.description) {
      setDescription(client.description);
    }
  }, [clientId, client]);

  return (
    <>
      <PageTitle title={'О клиенте'} />
      <PageHead
        scrollHeaderClassName={descriptionEditorStyles.scrollHeader}
        containerClassName={descriptionEditorStyles.pageHeadContainer}
        Left={<PageBackButton onClick={closePage} />}
        Right={
          <TextButton type="button" disabled={isUpdateClientLoading} onClick={handleClickSubmit}>
            Готово
          </TextButton>
        }
      />
      <ListBody className={descriptionEditorStyles.main}>{bodyJSX}</ListBody>
    </>
  );
};
